var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fm-tree',{ref:"tree",attrs:{"placeholder":"菜单权限","multiple":"","nodes":_vm.nodes,"search":"","is-checked":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }